// Load Lang selector
$(document).ready(function() {
    function wLang() {
        var curUrl = window.location.href;
        var pageUrl = '';
        var match = curUrl.match(/https?:\/\/(?:www\.)?(?:[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)?(?:127.0.0.1:[0-9]{4})?(?:\/[a-z]{2}\/)?(.*)/);
        if (match && match[1]) {
            pageUrl = match[1];
        }
        $('#wLangSelector ul.menuDropdown li').each(function() {
            var ahEle = $(this).find('a');
            var lang = ahEle.attr('lang');
            var newHref = '/' + lang + '/' + pageUrl;
            console.log(newHref);
            newHref = newHref.replace('/es/','/').replace('\/\/','/');
            ahEle.attr('href', newHref);
        });
    }
    wLang();
});